import { api } from "./client";

const messages = {
  ai: (category = "safety", lang = "es", fresh = false) =>
    api.get(`/messages/ai`, { params: { category, lang, fresh } }),
  random: (lang = "es", fresh = false) =>
    api.get(`/messages/ai/random`, { params: { lang, fresh } }),
};

export default messages;
